import { createStore, combineReducers, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import dataReducer from './reducers/dataReducer'
import endReducer from './reducers/EndDateReducer'
import notificationReducer from './reducers/NotificationReducer'
import startReducer from './reducers/StartDateReducer'
// Redux importit ja niiden wrapperi
const reducer = combineReducers({
  notification: notificationReducer,
  start: startReducer,
  end: endReducer,
  data: dataReducer
})

const store = createStore(
  reducer,
  composeWithDevTools(
    applyMiddleware(thunk)
  )
)

export default store